<template>
  <b-form-row>
    <b-modal size="xl" button-size="sm" :id="this.id" ref="finder" hide-footer :title="title">
      <TipoEstadoConservacaoList @onDblClickEstadoConservacao="tipoEstadoConservacaoSelect" :isModal="isModal"
        :prefix="updatedPrefix" />
    </b-modal>
    <lg-form-input-finder :value='computedValue' @input='updateValue' fieldDescription="descricao"
      :label="label" invalidFeedback="Estado Conservação deve ser informada!" description="" @clear="handleClean">
      <template #prepend>
        <b-button @click="show" class="btn-input-finder" pressed>
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import TipoEstadoConservacaoList from "@/modules/cadastros/tipo-estado-conservacao/TipoEstadoConservacaoList.vue"

export default {
  components: { LgFormInputFinder, TipoEstadoConservacaoList },

  props: {
    id: String,
    onSelect: Function,
    onClear: Function,
    value: [Object, String],
    isModal: Boolean,
    prefix: Array,
    label: {
      type: String,
      default: "Tipo de Estado:",
    },
  },

  data() {
    return {
      internalValue: this.value || {},
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.internalValue
      },
      set(newValue) {
        this.internalValue = newValue
      },
    },
    updatedPrefix() {
      return [...this.prefix, "Tipo Estado de Conservação"]
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
  },
  methods: {
    async show() {
      await this.$refs.finder.show()
    },
    updateValue(newValue) {
      this.computedValue = newValue
      this.$emit("input", newValue)
    },
    handleClean() {
      this.computedValue = {}
      this.$emit("input", {})
    },
    async tipoEstadoConservacaoSelect(item) {
      this.computedValue = item
      this.$emit("input", item)
      this.$bvModal.hide(this.id)
    },
  },
}
</script>
